var $6f5745e389c346d7$exports = {};
$6f5745e389c346d7$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Der Wert muss ".concat(args.maxValue, " oder fr\xFCher sein.");
  },
  "rangeReversed": "Das Anfangsdatum muss vor dem Enddatum liegen.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Der Wert muss ".concat(args.minValue, " oder sp\xE4ter sein.");
  },
  "unavailableDate": "Das ausgew\xE4hlte Datum ist nicht verf\xFCgbar."
};
export { $6f5745e389c346d7$exports as default };